// URL sanitization for any string that becomes an `href`.
//
// React does not block `javascript:` or `data:` URLs in `href` attributes —
// it only logs a dev-mode warning and still renders the anchor. Any URL that
// originates from the backend SSE stream (citations, deep-link CTAs) must be
// run through this helper before being assigned to `href`. Non-http(s) inputs
// are replaced with "#" so a malformed or hostile URL renders as a no-op link
// instead of executing script in the user's session.
export function safeUrl(raw: unknown): string {
  if (typeof raw !== 'string') return '#';
  const trimmed = raw.trim();
  if (!trimmed) return '#';
  // Allow same-origin relative URLs only. Protocol-relative `//host` is
  // intentionally NOT passed through — `//attacker.com` resolves to
  // `https://attacker.com`, not the page origin, and would be an open redirect.
  if (trimmed.startsWith('/') && !trimmed.startsWith('//')) return trimmed;
  if (trimmed.startsWith('#') || trimmed.startsWith('?')) return trimmed;
  try {
    const u = new URL(trimmed);
    if (u.protocol === 'http:' || u.protocol === 'https:') return u.href;
  } catch {
    // Falls through to the safe default.
  }
  return '#';
}
